import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';
import productTileTemplate from './productTileTemplate';
import { saveRecentlyViewedCookie, extractRecentlyViewedProducts } from './recentlyViewedCookie';
// import { formatProductPrices } from '../../core/helpers';
import sliderADA from '../../components/slider/ada';

const slides_to_show_desktop = 5.5;
let center_mode_desktop = false;

const initSlider = () => {
  // Only one slider element supported per page

  const slider = document.querySelector('[data-recently-viewed-products-slider].swiper');
  if (!slider) return;

  new Swiper(slider, {
    modules: [ Navigation, A11y, FreeMode ],
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 2.3,
    slidesPerGroup: 1,
    spaceBetween: 20,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: true,
    freeMode: true,
    autoplay: false,
    cssMode: false,
    centeredSlides: center_mode_desktop,
    breakpoints: {
      769: {
        slidesPerView: slides_to_show_desktop,
        slidesPerGroup: Math.floor(slides_to_show_desktop),
        freeMode: false,
        navigation: {
          nextEl: '.recently-viewed-products .swiper-button-next',
          prevEl: '.recently-viewed-products .swiper-button-prev',
        },
      }
    },
    on: {
      init: function () {
        animate();
        sliderADA(slider);
      },
    }
  });
};

export default () => {
  saveRecentlyViewedCookie();

  const slider = document.querySelector('[data-recently-viewed-products-slider].swiper');
  if (!slider) {
    return;
  }

  const viewed_products = extractRecentlyViewedProducts();

  if (!viewed_products || !viewed_products.length) {
    const section = document.querySelector('.recently-viewed-products-section');
    if (section) section.remove();
    return;
  }

  // Create the product tiles
  try {
    // viewed_products = formatProductPrices(viewed_products, true);

    const products_tiles_html = viewed_products.map((product, index) => {
      return productTileTemplate(product);
    }).join('');
  
    const wrapper = slider.querySelector('.swiper-wrapper');
    if (wrapper) wrapper.innerHTML = products_tiles_html;
  } catch (error) {
    console.log(error);
  }

  if (viewed_products.length < slides_to_show_desktop) {
    center_mode_desktop = false;
  }

  window.setTimeout(() => {
    initSlider();
  }, 100);
};
